module.exports = __webpack_public_path__ + "media/assets/icons/bin2-26e08fc2c44f4fb386024fede19baf74.svg";